import service from '@/utils/request';
import axios from 'axios'; // 获取订单发票列表
// @Tags orderManage
// @Summary 分页获取订单发票列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取订单发票列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/invoice/v1/getList [get]

export var getInvoiceList = function getInvoiceList(params) {
  return service({
    url: '/orderManage/invoice/v1/getList',
    method: 'get',
    params: params
  });
}; // 发票冲红
// @Tags orderManage
// @Summary 发票冲红
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "发票冲红"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/invoice/v1/fuyou/void [post]

export var invoiceFuyouVoid = function invoiceFuyouVoid(data) {
  return service({
    url: '/orderManage/invoice/v1/fuyou/void',
    method: 'post',
    data: data
  });
}; // 发票实时查询
// @Tags orderManage
// @Summary 发票实时查询
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "发票实时查询"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/invoice/v1/fuyou/query [post]

export var invoiceFuyouQuery = function invoiceFuyouQuery(data) {
  return service({
    url: '/orderManage/invoice/v1/fuyou/query',
    method: 'post',
    data: data
  });
}; // 发票重开（获取自开票h5地址）
// @Router /inner/ps/invoice/v1/fuyou/drawSelf [post]

export var invoiceFuyouDrawSelf = function invoiceFuyouDrawSelf(data) {
  return service({
    url: '/orderManage/invoice/v1/fuyou/drawSelf',
    method: 'post',
    data: data,
    donNotShowError: true
  });
}; // 发票换开（与小程序 pages/invoice_redo 调用的是同一个公开接口，在客户端服务上，不在本后台服务里）
// 不走上面的 service 实例：它会带上 x-token/x-user-id，这两个头不在该接口的 CORS 白名单里，浏览器预检会失败。
// 请求体也按小程序 utils/httputil.js 的写法（JSON 字符串 + form-urlencoded），既和线上一致，也不会触发预检。
// @Router /client/user/v1/invoice/Redo [post]

export var invoiceRedo = function invoiceRedo(data) {
  return service({
    url: '/orderManage/invoice/v1/fuyou/Redo',
    method: 'post',
    data: data,
    donNotShowError: true
  });
};